













import AlertDeliveryConfigRemove from "@/components/AlertDeliveryConfigRemove.vue";
import { Component, Vue, Prop } from "vue-property-decorator";
import { DeliveryConfig } from "@/types/alert";

@Component({ components: { AlertDeliveryConfigRemove } })
export default class AlertsDeliveryConfigItem extends Vue {
  @Prop({ required: true })
  deliveryConfig!: DeliveryConfig;

  @Prop({ required: false, default: false })
  isDisabled!: boolean;
}
